module.exports = __webpack_public_path__ + "img/various-bac-top.937c586c.png";